export const USA_ID = 157;
export const CANADA_ID = 82;
export const SMARTY_STREETS_AUTH_ID = "486319356736177";
export const PASSWORD_REGEX = new RegExp("^[a-zA-Z0-9\!\@\#\$\%\^\&\*\(\)]{0,}$");